import { useDispatch, useSelector } from "react-redux"
import ImageUpload from "screens/components/basic/ImageUpload"
import DeleteIcon from '@mui/icons-material/Delete';
import * as types from 'constants/actionTypes';

const UploadIcon = ({ favIcon, setIcon }) => {
  const img = useSelector(state => state.form.SEOSettingsIconImageURL)
  const dispatch = useDispatch()

  return (
    <div className="upload-icon-container" >
      <div className="prv" >
        {(img || favIcon) && <div>
          {(img || favIcon) && <span className="remove-spn" onClick={() => { dispatch({ type: types.FORM_INPUT, value: null, name: "SEOSettingsIconImageURL" }); setIcon() }}><DeleteIcon /></span>}
          <img src={img ? img : favIcon ? favIcon : ""} />
        </div>
        }
      </div>
      <div>
        <ImageUpload name={`SEOSettingsIconImageURL`} text={"Upload Favicon"} accept=".ico" displayPreview={false} />
      </div>

    </div>
  )
}


export default UploadIcon
